import { render, staticRenderFns } from "./HrAdmDispute.vue?vue&type=template&id=22c8c584&scoped=true&"
import script from "./HrAdmDispute.vue?vue&type=script&lang=js&"
export * from "./HrAdmDispute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c8c584",
  null
  
)

export default component.exports